import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Text from '../text/text';
import TextButton from '../textButton/textButton';
import InfoIcon from '../infoIcon';
import { dataHooks } from './constants';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
var NOTIFICATION_BANNER_SKINS = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  ALERT: 'alert',
  SUCCESS: 'success'
};
var NOTIFICATION_BANNER_ICON_TYPES = {
  INFO: 'info',
  ALERT: 'alert'
};

var NotificationBanner = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NotificationBanner, _React$PureComponent);

  var _super = _createSuper(NotificationBanner);

  function NotificationBanner() {
    _classCallCheck(this, NotificationBanner);

    return _super.apply(this, arguments);
  }

  _createClass(NotificationBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook,
          skin = _this$props.skin,
          text = _this$props.text,
          link = _this$props.link,
          icon = _this$props.icon,
          multiline = _this$props.multiline,
          shouldTranslate = _this$props.shouldTranslate;
      var rootClassName = classNames(getClassName('notification-banner'), "notification-banner-skin-".concat(skin));

      var getProps = function getProps() {
        var dynamicProps = {
          dataHook: dataHooks.notificationLink,
          skin: skin,
          shouldTranslate: shouldTranslate
        };

        if (link.onClick) {
          dynamicProps.onClick = link.onClick;
        } else {
          dynamicProps.as = 'a';
          dynamicProps.href = link.href;
          dynamicProps.target = link.target;
        }

        return dynamicProps;
      };
      /**
       * Text should be in the center and icon should be in the right, so we use 3 divs to achieve it
       * using flex space-between
       * That's why need the empty div and a div container for the icon
       */


      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: rootClassName
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
        className: "notification-banner-contents",
        style: {
          '--maxLines': multiline ? 2 : 1
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "notification-banner-text"
      }, /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.notificationText,
        skin: "secondary",
        size: "small",
        weight: 'thin',
        shouldTranslate: shouldTranslate
      }, text)), link && /*#__PURE__*/React.createElement("div", {
        className: "notification-banner-link"
      }, "\xA0", /*#__PURE__*/React.createElement(TextButton, _extends({
        size: 'small',
        weight: 'thin'
      }, getProps()), link.label))), /*#__PURE__*/React.createElement("div", null, icon && /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: dataHooks.notificationBannerIcon,
        text: icon.tooltipText,
        className: "notification-banner-icon",
        error: icon.type === NOTIFICATION_BANNER_ICON_TYPES.ALERT,
        shouldTranslate: shouldTranslate
      })));
    }
  }]);

  return NotificationBanner;
}(React.PureComponent);

NotificationBanner.displayName = displayNames.NOTIFICATION_BANNER;
NotificationBanner.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Notification label */
  text: PropTypes.string.isRequired,

  /** Changes visual theme */
  skin: PropTypes.oneOf(Object.values(NOTIFICATION_BANNER_SKINS)),

  /** Make text up to 2 lines if needed */
  multiline: PropTypes.bool,

  /** Display an info icon */
  icon: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(NOTIFICATION_BANNER_ICON_TYPES)),
    tooltipText: PropTypes.string
  }),

  /** Link */
  link: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    href: PropTypes.string,
    target: PropTypes.string
  }),
  shouldTranslate: PropTypes.bool
};
NotificationBanner.defaultProps = {
  skin: NOTIFICATION_BANNER_SKINS.STANDARD,
  multiline: false
};
export default compose(NotificationBanner);